import React from 'react'
import {Link} from 'react-router-dom'
import Slider from 'react-slick';
import Brand from '../indexone/Brand';
function ShopAreaTwo() {

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll:1,
    center:false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          SlidesToScroll: 1,
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  }
  return (
	 <section className="shop-area black-bg pt-40 pb-30">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  <div className="section-title title-style-three white-title text-center mb-40">
                    <h2>Our <span>Partners</span></h2>
                    <p>We collaborate with industry leaders to bring world-class gaming experiences. Together, we build, grow, and innovate.</p>
                  </div>
                </div>
              </div>
             	<Brand/>
            </div>
          </section>
  )
}

export default ShopAreaTwo